import { useEffect, useState } from 'react';

const CURRENT_VERSION = process.env.REACT_APP_VERSION || 'dev';
const CHECK_INTERVAL = 10 * 60 * 1000; // 10 minutes

export const useVersionCheck = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        // Cache-busting: query string ensures fresh fetch every time
        const response = await fetch('/meta.json?t=' + Date.now(), {
          cache: 'no-cache',  // Additional cache bypass
          headers: {
            'Cache-Control': 'no-cache'
          }
        });
        
        if (!response.ok) return;
        
        const deployedMeta = await response.json();
        
        if (deployedMeta.version !== CURRENT_VERSION) {
          console.log('New version detected:', deployedMeta.version);
          setUpdateAvailable(true);
        }
      } catch (error) {
        console.log('Version check failed:', error);
      }
    };

    checkVersion();
    const interval = setInterval(checkVersion, CHECK_INTERVAL);
    
    return () => clearInterval(interval);
  }, []);

  return { updateAvailable };
};